var React = require('react');

function VolumeoffInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M9 15V1L4.25 5.05H1v5.9h3.25z"}));
}

VolumeoffInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = VolumeoffInline;

VolumeoffInline.default = VolumeoffInline;
